import React from 'react';
import './Styles.css';
import ContactSection from '../../components/ContactSectionPage/Index';
import useTitle from '../../useTitle';

const NotFound = () => {
    useTitle("Error 404 - Not Found")
  return (
    <>
        <div className="notFoundPageSectionContainer">
            <div className='notFoundTitlePageSection'>
                <h1 className='notFoundTitle'>Error 404 - Not Found</h1>
            </div>
            <div className='noProductsContainer'>
                <p className='noProductsMessage'>
                    Oops! The page you're looking for doesn't exist or has been moved.
                </p>
                <p className='noProductsMessage'>
                    Please check the URL or go back to our homepage.
                </p>
            </div>
            <div className='notFoundButtonContainer'>
                <button onClick={() => window.location.href = "/"} className='notFoundButton'>Go back to the Homepage</button>
            </div>
        </div>
        <ContactSection />
    </>
  );
};

export default NotFound;